module.exports = {
	"shared.crew.original-music-composer": "音楽",
	"social-button.twitter": "Twitter",
	"shared.crew.publicist": "広報",
	"share-overlay.share": "動画をシェア",
	"shared.crew.associate-producer": "プロデューサー補",
	"shared.crew.assistant-editor": "編集助手",
	"overlay.buy-from": "{price} で購入",
	"shared.crew.agent": "キャスティング",
	"shared.crew.additional-photography": "スチール",
	"shared.crew.sound-editor": "録音",
	"shared.crew.print-shipper": "音響",
	"shared.crew.hairstylist": "ヘアスタイリスト",
	"shared.crew.makeup-effects": "特殊メイク",
	"social-button.pinterest": "Pinterest",
	"shared.crew.production-assistant": "制作進行",
	"shared.crew.executive-producer": "製作総指揮",
	"shared.crew.costumer": "衣装",
	"info-overlay.cast": "キャスト",
	"shared.crew.stunt-coordinator": "スタント",
	"shared.crew.academic-advisor": "アドバイザー",
	"shared.crew.swing-gang": "搬入・撤収",
	"shared.crew.best-boy": "第一助手",
	"actions.purchased": "購入済みの動画です",
	"social-button.tumblr": "Tumblr",
	"quality.format": "{qualityValue}p",
	"shared.crew.set-decorator": "装飾",
	"shared.crew.adaptation": "脚本（脚色）",
	"shared.crew.school-administrator": "講師",
	"shared.crew.cable-person": "ケーブル操作",
	"shared.crew.digital-effects": "CG",
	"actions.rent": "{price} でレンタル",
	"info-overlay.created-by": "By {author}",
	"social-share.twitter": "\"{title}\" を {siteUrl} で見よう",
	"shared.crew.production-designer": "美術監督",
	"info-overlay.crew": "スタッフ",
	"shared.crew.producer": "制作",
	"shared.crew.2nd-unit-dir-of-photography": "第2班監督",
	"shared.crew.special-effects": "特殊効果",
	"actions.rented": "{date} まで視聴可能",
	"shared.crew.boom-operator": "録音助手",
	"shared.crew.story": "声の出演",
	"shared.crew.script-supervisor": "記録",
	"shared.crew.director": "監督",
	"shared.crew.choreographer": "振り付け",
	"shared.crew.production-manager": "制作主任",
	"quality.auto": "自動",
	"shared.crew.lead-person": "大道具",
	"shared.crew.location-manager": "ロケーション",
	"shared.crew.costume-designer": "衣装デザイナー",
	"fullscreen.exit": "全画面を終了",
	"shared.crew.technical-advisor": "技術指導",
	"shared.crew.editor": "編集",
	"shared.crew.additional-grip": "特機補",
	"actions.buy": "{price} で購入",
	"shared.crew.assistant-camera": "撮影助手",
	"shared.crew.writer": "脚本",
	"social-share.pinterest": "{title} - {description}",
	"shared.crew.collaborating-director": "監督（協力）",
	"fullscreen.enter": "全画面",
	"shared.crew.animal-trainer": "動物トレーナー",
	"shared.crew.assistant-art-director": "美術助手",
	"shared.crew.key-grip": "特機",
	"social-button.copy": "コピー",
	"shared.crew.makeup-artist": "メイク",
	"overlay.source-error": "動画を再生できません",
	"social-button.link": "リンク",
	"actions.buy-from": "{price} で購入",
	"shared.crew.art-director": "アートディレクター",
	"shared.crew.production-coordinator": "コーディネーター",
	"shared.crew.co-director": "共同監督",
	"shared.crew.co-producer": "共同プロデューサー",
	"shared.crew.video-operator": "映像撮影",
	"shared.crew.camera-operator": "撮影技師",
	"shared.crew.co-writer": "共同脚本",
	"shared.crew.set-designer": "美術デザイナー",
	"shared.crew.preview-return": "撮影協力",
	"shared.crew.property-master": "小道具",
	"shared.crew.cinematographer-dp": "撮影監督",
	"shared.crew.grip": "特機助手",
	"social-share.tumblr": "{title} - {siteUrl}",
	"shared.crew.sound-mixer": "音声編集",
	"quality.label": "画質",
	"social-button.facebook": "Facebook",
	"shared.crew.gaffer": "照明",
	"shared.crew.assistant-director": "助監督",
	"actions.subscribe": "定期購入：{price} / 月",
	"shared.crew.print-return": "演出",
	"shared.crew.animator": "アニメーター",
	"shared.crew.dolly-grip": "特機（ドリー）",
	"shared.crew.manager": "主任",
	"shared.crew.2nd-assistant-director": "助監督（セカンド）",
	"shared.crew.author-of-adapted-material": "原作"
};


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations/widget-texts_ja.json
// module id = 1442
// module chunks = 0 1 2 3